const tryParseNumber = (value: string) => (
    Number.isNaN(parseFloat(value))
        ? null
        : parseFloat(value)
);

export default tryParseNumber;
